import React from 'react';
import { journey } from '../../mock';

const Journey = () => {
  return (
    <section id="journey" className="py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="max-w-3xl reveal">
          <div className="text-xs uppercase tracking-[0.24em] text-[var(--brand-gold)] mb-4">Your Journey With Elevate</div>
          <h2 className="font-serif text-4xl lg:text-6xl text-green tracking-tight leading-[1.04]">
            Six clear steps, <em className="italic">one lasting</em> transformation.
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {journey.map((s, i) => (
            <div
              key={s.step}
              className="reveal card-hover relative rounded-2xl p-6 border border-[rgba(31,58,46,0.08)] bg-[var(--brand-cream-2)]"
            >
              <div className="absolute -top-3 left-6 h-6 px-3 rounded-full bg-[var(--brand-green)] text-[var(--brand-cream)] text-[10px] uppercase tracking-[0.22em] flex items-center">
                Step {s.step}
              </div>
              <div className="font-serif text-2xl text-green leading-tight mt-2">{s.title}</div>
              <p className="mt-3 text-sm text-[var(--brand-mute)] leading-relaxed">{s.desc}</p>
              <div className="mt-6 flex items-center gap-3">
                <div className="h-px flex-1 bg-[rgba(31,58,46,0.15)]" />
                <div className="text-xs text-[var(--brand-gold)] font-medium">0{i + 1} / 06</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Journey;
